import * as z from "zod";

/**
 * Revoke a stored exclusion by id, RESUMING billing on its population.
 * Trusted checkout-optimization users only; scoped to the caller's account.
 */
export const revokeCheckoutExclusion = {
  name: "revokeCheckoutExclusion" as const,
  input: z.object({ exclusionId: z.string() }),
  output: z.null(),
};
